// angular
// 	.module("HeroPRO")
// 	.factory("TempDocumentFactory", tempDocumentFactory);

/* @ngInject */
export default function tempDocumentFactory($http, HPConfig) {
    return {
        generateTempDocument,
    };


    function generateTempDocument(fileName) {
        const getTempDocumentRequest = {
            FileName: fileName,
        };

        return $http({
            url: `${HPConfig.heroProApi}DocumentManagement/GenerateTempDocument`,
            method: 'POST',
            processData: false,
            data: getTempDocumentRequest,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/dataFactories/tempDocumentFactory.js